import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UserService } from '@app/services/user.service';
import { ResumeSendLoginModalComponent } from '../resume-send-login-modal/resume-send-login-modal.component';
import { ResumeSendModalComponent } from '../resume-send-modal/resume-send-modal.component';

declare var $: any;

@Component({
  selector: 'app-resume-send',
  templateUrl: './resume-send.component.html',
  styleUrls: ['./resume-send.component.css']
})
export class ResumeSendComponent {

  @ViewChild('resumeSendModal') resumeSendModal: ResumeSendModalComponent
  @ViewChild('resumeSendLoginModal') resumeSendLoginModal: ResumeSendLoginModalComponent;
  @Output() eventResumeSend = new EventEmitter<any>();

  constructor(private userService: UserService) { }

  setResumeSendApply(_idInstitution: number, institutionName: string, institutionAddressList: Array<any>, isCallEmployerPage: boolean) {

    if (!this.userService.isEmployee()) {
      this.resumeSendLoginModal.setValues(_idInstitution, institutionName, isCallEmployerPage);
      return;
    }

    $("#modal-send-cv-one-headquarters").modal('show');
    this.resumeSendModal.setIndividualMode(_idInstitution, institutionName, institutionAddressList)
  }

  setResumeSendApplyBulk(employerList: Array<number>, employerListName: Array<string>) {
    $("#modal-send-cv-one-headquarters").modal('show');
    this.resumeSendModal.setBulkMode(employerList, employerListName)
  }

  eventModalResumeSend(event) {
    this.eventResumeSend.next(event);
  }
}
